import cs from 'classnames';
import { useStyles } from '../style';

interface CellProps {
  color: string;
  expanded: boolean;
  secondary?: boolean;
}

const ColorCell = ({ color, expanded, secondary = false }: CellProps) => {
  const classes = useStyles({});

  return (
    <div className={cs(classes.colorCell, {})}>
      {!secondary ? (
        <>
          <div
            className={classes.colorMain}
            style={{ backgroundColor: color }}
          />
          {expanded && (
            <div
              className={classes.colorExpanded}
              style={{ backgroundColor: color }}
            />
          )}
        </>
      ) : (
        <div
          className={classes.colorSecondary}
          style={{ backgroundColor: color }}
        />
      )}
    </div>
  );
};

export default ColorCell;
